/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  AppCardListService,
  IAppCardListMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
} from "./components";

export type ActualPoliciesPageAgent = IHeaderMethods &
  ISettingsMethods &
  IAppCardListMethods &
  IStaticPageContentMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new SettingsService(),
    new AppCardListService(),
    new StaticPageContentService(),
  ];
};

export const getAgent = () => {
  return createAgent<ActualPoliciesPageAgent>({
    plugins: getPlugins(),
  });
};
